import { CircularProgress, Divider, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import TablePaginatedPay from 'widgets/Tables/TablePaginatedPay';
import TableSimple from 'widgets/Tables/TableSimple';
import { CardGeneric } from '../../components/CardGeneric';
import { API_GET_SETTINGS_COMPANY } from '../apis';
import AddConfigurationBtn from '../Buttons/AddConfigurationBtn';
import tableStyle from "configurations/styles/table";
import clientBackend from 'configurations/axios';
import { apiKey } from 'configurations/constant';
import EditConfigurationBtn from '../Buttons/EditConfigurationBtn'
import DeleteConfigurationBtn from '../Buttons/DeleteConfigurationBtn'
const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "35px",
        paddingBottom: "7%",
        flexGrow: 1,
        paddingLeft: "3%",
        paddingRight: "3%",
    },
    headerBottons: {
        padding: "0.5%",
    },
    loader: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        height: "300px"
    }
}));


const ConfigurationCompany = ({ rucEmpresa }) => {

    const classesView = useStyles();
    const [update, setUpdate] = useState(0);
    const [paramSearch, setParamSearch] = useState("");
    const [foundCompany, setFoundCompany] = useState([]);

    const columns = [
        { title: "Nombre", field: "configuracion.nombre", cellStyle: tableStyle.cellTable, },
        { title: "Descripción", field: "configuracion.descripcion", cellStyle: tableStyle.cellTable, },
        { title: "Valor", field: "valor", cellStyle: tableStyle.cellTable, },
        { title: "Editar", cellStyle: tableStyle.cellTable, render: rowData => <EditConfigurationBtn data={rowData} updateView={reload} /> },
        { title: "Eliminar", cellStyle: tableStyle.cellTable, render: rowData => <DeleteConfigurationBtn data={rowData} updateView={reload} /> },
    ];

    const requestConfig = {
        uri: API_GET_SETTINGS_COMPANY + rucEmpresa,
        metodo: "get",
        body: null,
        page: 0,
        elementos: 15,
        sort: "idConfiguracionEmpresa,asc",
    };

    const reload = () => {
        setUpdate(1);
    };

    const getParam = (data) => {
        setParamSearch(data);
        if (data.length > 0) {
            searchCompany(data);
        } else {
            reload();
        }
    };

    const searchCompany = async (param) => {
        setUpdate(3);
        await clientBackend
            .get(
                API_GET_SETTINGS_COMPANY +
                apiKey +
                "?parametroBusqueda=" +
                param
            )
            .then((response) => {
                if (response.status === 200) {
                    setFoundCompany(response.data);
                    setUpdate(2);
                }
            })
            .catch((exception) => {
                console.error({ exception });
            });
    };

    useEffect(() => {
        if (update === 1) {
            setUpdate(0);
        }
    }, [update]);

    const renderTable = () => {
        switch (update) {
            case 0:
                return (
                    <TablePaginatedPay
                        title=""
                        columns={columns}
                        requestConfig={requestConfig}
                        seleccion={false}
                    />
                );

            case 1:
            case 3:
                return (
                    <div className={classesView.loader}>
                        <CircularProgress />
                    </div>
                );
            case 2:
                return (
                    <TableSimple
                        columns={columns}
                        data={foundCompany}
                        title=""
                        numberRowsPerPage={15}
                    />
                );
            default:
                break;
        }
    };

    return (
        <div className={classesView.root}>
            <CardGeneric>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        {<AddConfigurationBtn rucEmpresa={rucEmpresa} updateView={reload}
                        />}
                    </Grid>
                </Grid>
            </CardGeneric>
            {renderTable()}
        </div>
    );
}

export default ConfigurationCompany;